export const HOME = {
  emergentLink: "emergent-link",
};

export const IDS = {
  scene: "dog-scene",
  dogSvg: "sleeping-dog-svg",
  windIndicator: "wind-indicator",
  seismogram: "seismogram",
  quakeList: "quake-list",
  quakeItem: "quake-item",
  latestQuake: "latest-quake",
  maxMag: "max-magnitude",
  status: "status-indicator",
  simulateBtn: "simulate-quake-btn",
  soundToggle: "sound-toggle",
  refreshBtn: "refresh-btn",
  woof: "woof-text",
  title: "hero-title",
  windDebug: "wind-debug-panel",
  windDebugClose: "wind-debug-close",
  windSlider: "wind-slider",
  magSlider: "mag-slider",
  fireBtn: "fire-btn",
  resetBtn: "reset-btn",
  windStamp: "wind-stamp",
  purrLabel: "purr-label",
  contentmentBadge: "contentment-badge",
};
